import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { cloneDeep } from 'lodash';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import { Router, RouterLinkWithHref } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { CONFIG } from 'src/helper/app-config';
import Swal from 'sweetalert2';
import { SCENARIO_KEYS_MAPPER } from 'src/app/shared/shared-config';
import {
  COMPLETED,
  DRAFT,
  EDIT,
  FAILED,
  NEW,
  OUTPUT_LIMIT,
  PROCESSING,
  SCENARIO_LIBRARY_LIMIT,
} from 'src/shared/data-store';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { errorOrSuccessPopup } from 'src/helper/utilities';

interface ScenarioNode {
  name: string;
  child?: ScenarioNode[];
  createdOn: string;
  created_by: string;
  status: boolean;
  type: string;
  base_id: string;
  volume?: string;
  month?: number;
  channel?: string;
  price?: string;
}

interface ExampleFlatNode {
  expandable?: boolean;
  name?: string;
  volume?: string;
  month?: number;
  channel?: string;
  price?: string;
  count?: number;
  level?: number;
  createdOn?: string;
  created_by?: string;
  status?: boolean;
  type: string;
  base_id: string;
}
@Component({
  selector: 'app-scenario-library',
  standalone: false,
  templateUrl: './scenario-library.component.html',
  styleUrls: ['./scenario-library.component.scss'],
})
export class ScenarioLibraryComponent implements OnInit {
  tabs = CONFIG.TABS.map((val) => val);

  @ViewChild(MatSort) sort: MatSort | undefined;
  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}
  fullData = [];
  status = {
    0: FAILED,
    1: COMPLETED,
    2: PROCESSING,
    3: DRAFT,
  };
  pageSize = SCENARIO_LIBRARY_LIMIT;
  userType;
  searchQuery = '';
  isRefreshed = false;
  usreConfig = CONFIG.USER_TYPES;
  showLoader = false;
  disabledTrue = true;
  childScenarioIds = [];
  outputLimit = OUTPUT_LIMIT;
  offset = 0;
  limit = SCENARIO_LIBRARY_LIMIT;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  scenarioCount = 0;
  disabled = true;
  requiredKeys = [
    'base_scenario_name',
    'name',
    'base_name',
    'child_scenario_name',
    SCENARIO_KEYS_MAPPER.CATEGORY,
    SCENARIO_KEYS_MAPPER.END_DATE,
    SCENARIO_KEYS_MAPPER.START_DATE,
    SCENARIO_KEYS_MAPPER.PRICE,
  ];
  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.dataService.showLoader.next(true);

    // this.showLoader = true;
    this.dataService.userType.subscribe((type) => {
      this.userType = type;
    });
    let payload = {
      // limit: this.limit,
      // offset: this.offset,
      limit: 1000,
      offset: 0,
    };
    // this.dataSource.data = [];
    this.dataService
      .postRequest(payload, CONFIG.API2.SCENARIO_LIST)
      .then((res: any) => {
        console.log(res);
        this.scenarioCount = res['data']['scenarios_count'];
        // let data = res === null ? [] : JSON.parse(res || '[]');
        this.commonDataMapper(res);
        // this.dataSource['paginator'] = this.paginator;
        // this.showLoader = false;
        this.dataService.showLoader.next(false);
      })
      .catch((err) => {
        this.showLoader = false;
        this.dataService.showLoader.next(false);
        console.log(err);
        errorOrSuccessPopup('Error', 'Something went wrong!', 'error');
      });
  }
  startIndex = 0;
  endIndex = this.limit / 2;

  conditionalDisplay(data) {
    if (data.child) {
      console.log(data);
      return false;
    }

    return true;
  }
  isSelected(id) {
    console.log(id);
    let result = this.childScenarioIds.find((o) => o.id == id);
    if (result) {
      true;
    }
    return false;
  }
  filterObject(obj, requiredKeys) {
    const filteredObject = {};

    requiredKeys.forEach((key) => {
      if (obj.hasOwnProperty(key)) {
        filteredObject[key] = obj[key];
      }
    });

    return filteredObject;
  }

  hidePagination = true;
  refresh() {
    this.isRefreshed = true;
    this.hidePagination = false;
    this.offset = 0;
    this.searchQuery = '';
    this.startIndex = 0;
    this.endIndex = this.limit / 2;
    this.fullData = [];
    this.dataSource.data = [];
    // this.paginator.pageIndex === 0
    //   ? this.getData()
    //   : this.paginator.firstPage();
    this.getData();
    this.hidePagination = true;
    this.isRefreshed = false;
  }
  commonDataMapper(data) {
    let arr = data.data['scenarios'].map((obj) => {
      obj['name'] = obj['base_scenario_name'];
      obj['createdOn'] = obj['created_on'];
      obj['status'] = '';
      obj['type'] = 'base';
      obj['base_id'] = obj['id'];
      // obj['volume'] = 'test';
      // obj['month'] = '2';
      // obj['price'] = '20';

      obj['child'] = obj['child'].length
        ? this.childMapper(obj['child'], obj['base_scenario_name'])
        : [];
      return obj;
    });
    arr = arr.reverse();
    // arr = [...this.fullData, ...arr];
    this.fullData = cloneDeep(arr);
    // this.dataSource.data = arr.slice(this.startIndex, this.endIndex);
    this.dataSource.data = arr;
  }
  commonDataMapperForSearch(data) {
    let arr = data.data['scenarios'].map((obj) => {
      obj['name'] = obj['base_scenario_name'];
      obj['createdOn'] = obj['created_on'];
      obj['status'] = '';
      obj['type'] = 'base';
      obj['base_id'] = obj['id'];
      // obj['volume'] = 'test';
      // obj['month'] = '2';
      // obj['price'] = '20';

      obj['child'] = obj['child'].length ? this.childMapper(obj['child']) : [];
      return obj;
    });
    // arr = arr.reverse();
    arr = [...this.fullData, ...arr];
    this.fullData = cloneDeep(arr);
    this.dataSource.data = arr;
    // this.dataSource.data = arr;
  }
  paginationChange({ pageIndex, pageSize }) {
    this.offset = this.isRefreshed == true ? 0 : this.offset + this.limit;
    this.startIndex = pageIndex * (this.limit / 2);
    this.endIndex = this.startIndex + this.limit / 2;
    this.getData();
  }

  createNewChildScenario(id: any, baseName) {
    let baseScenario = this.extractBaseScenario(id, baseName);
    delete baseScenario.child;
    baseScenario = this.filterObject(baseScenario, this.requiredKeys);
    this.router.navigate(['/scenario-creation'], {
      queryParams: { tab: '1', baseDetails: JSON.stringify(baseScenario) },
    });
    this.resetStatus();
  }

  openChildScenario(id: any, scenarioName, childId, data, tab?, type?) {
    let baseScenario = this.extractBaseScenario(id);
    if (!childId) return;
    delete baseScenario.child;

    this.dataService.childMode.next(EDIT);
    let childData = this.filterObject(data, this.requiredKeys);
    baseScenario = this.filterObject(baseScenario, this.requiredKeys);

    this.router.navigate(['/scenario-creation'], {
      queryParams: {
        tab: tab ? tab : '1',
        baseDetails: JSON.stringify(baseScenario),
        childDetails: JSON.stringify(childData),
      },
    });
  }

  resetStatus() {
    this.dataService.childMode.next(NEW);
  }
  extractBaseScenario(id, baseName?) {
    let baseScenario;
    if (id) {
      baseScenario = this.fullData.find((obj) => obj.id == id);
    }
    baseScenario = this.fullData.find(
      (obj) => obj.base_scenario_name == baseName,
    );

    return baseScenario;
  }
  openOutputSummary(baseName: any, data) {
    let baseScenario = this.extractBaseScenario(null, baseName);

    delete baseScenario.child;
    let childData = this.filterObject(data, this.requiredKeys);
    baseScenario = this.filterObject(baseScenario, this.requiredKeys);

    this.router.navigate(['/scenario-creation'], {
      queryParams: {
        tab: '2',
        baseDetails: JSON.stringify(baseScenario),
        childDetails: JSON.stringify(childData),
      },
    });
  }

  childMapper(arr, baseName?) {
    return arr.map((obj) => {
      obj['name'] = obj['child_scenario_name'];
      obj['createdOn'] = obj['created_on'];
      obj['status'] = obj['status'];
      obj['checked'] = false;
      obj['type'] = 'child';
      obj['child_id'] = obj['child_id'];
      obj['base_name'] = baseName;
      // obj['volume'] = 'test';
      // obj['month'] = '2';
      // obj['price'] = '20';
      return obj;
    });
  }
  displayedColumns: string[] = [
    'name',
    // 'channel',
    // 'volume',
    // 'month',
    // 'price',
    // 'count',
    'created_by',
    'createdOn',
    'status',
    'output',
    'actions',
  ];

  private transformer = (node: ScenarioNode, level: number) => {
    return {
      expandable: !!node.child && node.child.length > 0,
      name: node.name,
      level: level,
      createdOn: node.createdOn,
      created_by: node.created_by,
      volume: node.volume,
      month: node.month,
      price: node.price,
      channel: node.channel,
      status: node.status,

      type: node.type,
      base_id: node.base_id,
      child_id: level === 1 ? node['child_id'] : '',
      base_name: level === 1 ? node['base_name'] : '',
      pe_type: node['pe_type'],
    };
  };

  treeControl = new FlatTreeControl<any>(
    (node) => node['level'],
    (node) => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.child,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  timeout;

  filterScenarios(searchInput) {
    let scenarioData = cloneDeep(this.fullData);
    return scenarioData.filter(function (scenario) {
      return scenario.base_scenario_name
        .toLowerCase()
        .includes(searchInput.toLowerCase());
    });
  }
  applySearch(event) {
    this.dataSource.data = this.filterScenarios(event);
  }

  searchTable(value) {
    this.searchQuery = value;
    this.offset = this.offset + this.limit;
    this.startIndex = 0 * (this.limit / 2);
    this.endIndex = this.startIndex + this.limit / 2;
    this.fullData = [];
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.dataService.showLoader.next(true);
      // do something with the debounced input value
      this.dataService
        .getRequest(CONFIG.API2.SEARCH_BASE_SCENARIOS + value)
        .then((res) => {
          let data = res === null ? [] : JSON.parse(res || '[]');
          this.scenarioCount = data['data']['scenarios_count'];
          // console.log(res);
          this.commonDataMapperForSearch(data);
          this.dataService.showLoader.next(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }, 500);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // this.dataSource.paginator= this.paginator;
    }, 3000);

    console.log('datasource', this.dataSource);
  }
  removePreviouslySelectedChildIds() {
    this.childScenarioIds = [];
  }

  redirectToCreateBase() {
    this.router.navigate(['/scenario-creation'], { queryParams: { tab: '0' } });
    this.dataService.childMode.next('');
    this.dataService.priceScenarioTableData.next([]);
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  deleteChild(e, data) {
    console.log('DATA======', data);
    e.stopPropagation();
    let payload = {
      base_scenario_name: data.base_name,
      child_scenario_name: data.name,
    };
    Swal.fire({
      title: 'Delete',
      html: `<h3>Are you sure, You want to delete <b> ${data.name} </b> ?</h3>`,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText: 'Cancel',
      cancelButtonAriaLabel: 'Thumbs down',
      confirmButtonColor: '#25d4cf',
    }).then((a) => {
      if (a['isConfirmed']) {
        this.dataService.showLoader.next(true);
        this.fullData = [];
        this.dataService
          .postRequest(payload, CONFIG.API2.DELETE_CHILD)
          .then((res) => {
            this.dataService.showLoader.next(false);

            console.log(res);
            Swal.fire({
              icon: 'success',
              title: 'Deleted successfully !!!',
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              // this.getData();
              this.ngOnInit();
              // this.startIndex = 0;
              // this.endIndex = this.limit / 2;
              // this.paginator.pageIndex = 0;
              // this.offset = 0;
              // this.dataSource.data = [];
            });
            // }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }
  deletePlan(e, row) {
    e.stopPropagation();
    let payload = {
      base_scenario_name: row.name,
      id: row.child_id ? row.child_id : row.base_id,
      type: row.child_id ? 'child' : 'base',
    };
    console.log('DELETE', payload, row);
    Swal.fire({
      title: 'Delete',
      html: `<h3>Are you sure, You want to delete <b> ${row.name} </b> ?</h3>`,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText: 'Cancel',
      cancelButtonAriaLabel: 'Thumbs down',
      confirmButtonColor: '#25d4cf',
    }).then((a) => {
      if (a['isConfirmed']) {
        this.dataService.showLoader.next(true);
        this.fullData = [];
        this.dataService
          .postRequest(payload, CONFIG.API2.DELETE_BASE)
          .then((res) => {
            this.dataService.showLoader.next(false);

            console.log(res);
            Swal.fire({
              icon: 'success',
              title: 'Deleted successfully !!!',
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.ngOnInit();
              // this.startIndex = 0;
              // this.endIndex = this.limit / 2;
              // this.paginator.pageIndex = 0;
              // this.offset = 0;
              // this.dataSource.data = [];
              // this.getData();
            });
            // }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }
}
